import { defineComponent as _defineComponent } from 'vue'

import type FamilyGroup from "../../../../backend/app/models/family_group";


export default /*@__PURE__*/_defineComponent({
  __name: '[id]',
  setup(__props) {

const route = useRoute();
const id = route.params.id;
const familyGroupsStore = useGroupStore();

definePageMeta({
  layout: "dashboard",
  middleware: "auth",
});

useHead({
  title: "Family Group",
  meta: [{ name: "description", content: "Dashboard Home" }],
  bodyAttrs: {
    class: "dashboard",
  },
});

// Define the ref for groups, initially empty or based on a default
const group = ref<FamilyGroup>();

// Use watchEffect to track changes in the store's groups
watchEffect(() => {
  if (familyGroupsStore.groups) {
    group.value = familyGroupsStore.groups.filter(
      (group) => group.id == Number(id),
    )[0] as FamilyGroup;
  }
});

return (_ctx: any,_cache: any) => {
  return null
}
}

})